// apps/dashboard/src/lib/pwa-prompt-routes.ts

// The install banner is `fixed ... bottom-20 z-30`, which on a phone-sized viewport lands
// exactly on top of the primary call to action. Measured against production in WebKit
// (iOS Safari engine): on iPhone 14 and iPhone SE it covered BOTH the "Masuk" submit button
// and the Google sign-in button; on iPhone 14 Pro Max it still covered the Google button.
// Taps hit the banner instead of the button, so users could not sign in at all.
//
// Suppressing it on these routes rather than restyling it: a user midway through signing in
// or onboarding is the worst possible moment to pitch a home-screen install, so there is no
// layout worth fixing here. Everywhere else the banner is unchanged.
const CTA_CRITICAL_PREFIXES = [
  '/login',
  '/register',
  '/forgot-password',
  '/verify-email',
  '/onboarding',
  '/claim',
  '/join',
];

export function isCtaCriticalRoute(pathname: string | null): boolean {
  if (!pathname) return false;
  return CTA_CRITICAL_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
